import React from "react";
import { PageHero, SectionHeading } from "../components/Sections";
import { Card } from "../components/ui/card";
import { Icon } from "../components/icons";
import { LeadForm } from "../components/LeadForm";
import { insuranceProducts } from "../mock/data";
import { Info } from "lucide-react";

export default function Insurance() {
  return (
    <div>
      <PageHero
        title="Insurance Options for You and Your Family"
        subtitle="Explore health, life and motor insurance. Policies are offered by authorised insurers/intermediaries under the applicable IRDAI framework."
        crumbs={[{ label: "Insurance" }]}
      />

      <section className="section-pad">
        <div className="container-page">
          <div className="mb-10 flex items-start gap-3 rounded-xl border border-primary/20 bg-secondary/50 p-4">
            <Info className="h-5 w-5 shrink-0 text-primary" />
            <p className="text-sm text-muted-foreground">
              <strong className="text-foreground">Important: </strong>Insurance is regulated separately from lending.
              Where we facilitate insurance, we refer enquiries to an authorised insurance intermediary/insurer. Policy
              issuance, pricing and claims are handled by the authorised entity. Insurance products are subject to policy
              terms and conditions. Please review details before purchase.
            </p>
          </div>

          <SectionHeading eyebrow="Insurance" title="Protect what matters most"
            desc="Insurance advertising here is intended to be clear, fair and not misleading." />

          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
            {insuranceProducts.map((p) => (
              <Card key={p.title} className="svc-card h-full border p-6">
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-secondary text-primary">
                  <Icon name={p.icon} className="h-6 w-6" />
                </div>
                <h3 className="mt-4 font-heading text-lg font-semibold">{p.title}</h3>
                <p className="mt-1.5 text-sm text-muted-foreground">{p.desc}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="pb-20">
        <div className="container-page">
          <Card className="mx-auto max-w-2xl border p-6 md:p-8 shadow-sm">
            <h3 className="font-heading text-xl font-bold text-center">Enquire about Insurance</h3>
            <p className="mt-1 text-center text-sm text-muted-foreground">
              Share your details and our team will connect you with an authorised partner.
            </p>
            <div className="mt-6"><LeadForm defaultType="Health Insurance" /></div>
          </Card>
        </div>
      </section>
    </div>
  );
}
